// Celular da conta: obrigatório para conta Google, só do Brasil. O número só volta para o próprio dono, pela API; a
// mesa confere no banco se a conta tem celular antes de sentar e responde falta_celular quando não tem.
import { normalizarCelular } from '@truco6/localidades/celular';
import { api } from './api.ts';
import type { Sessao } from './conta.ts';

export { formatarCelular, mascararDigitando } from '@truco6/localidades/celular';

export interface MeuCelular { celular: string | null; avisosWhatsapp: boolean; whatsappAmigos: boolean }

export const lerMeuCelular = (s: Sessao) => api<MeuCelular>(s, 'GET', '/eu/celular');
// Grava ou troca o número. A caixa dos avisos pelo WhatsApp vai junto quando a tela tem a caixa.
export const guardarMeuCelular = (s: Sessao, celular: string, avisosWhatsapp?: boolean) =>
  api<MeuCelular>(s, 'PUT', '/eu/celular', avisosWhatsapp === undefined ? { celular } : { celular, avisosWhatsapp });
export const mudarAvisosWhatsapp = (s: Sessao, ligado: boolean) => api<MeuCelular>(s, 'PUT', '/eu/avisos-whatsapp', { ligado });

export const celularValido = (texto: string) => normalizarCelular(texto) !== null;
// Com os 11 dígitos digitados e fora do formato, o aviso aparece antes de enviar.
export const AVISO_FORMATO = 'Informe um celular do Brasil com DDD, como (11) 98765-4321.';
export const avisoDoCelular = (texto: string) => (texto.replace(/\D/g, '').length >= 11 && !celularValido(texto) ? AVISO_FORMATO : null);

// O convidado guardou a conta com Google: a folha "Falta seu celular" abre logo depois da volta, uma vez.
const CHAVE_NA_VOLTA = 'truco6:celular-na-volta';
export function pedirCelularNaVolta(): void {
  try { localStorage.setItem(CHAVE_NA_VOLTA, '1'); } catch { /* sem armazenamento: a folha abre ao sentar */ }
}
export function temPedidoDeCelular(): boolean {
  try { return localStorage.getItem(CHAVE_NA_VOLTA) === '1'; } catch { return false; }
}
export function tirarPedidoDeCelular(): void {
  try { localStorage.removeItem(CHAVE_NA_VOLTA); } catch { /* sem armazenamento */ }
}
